import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { getDealsErrors } from 'selectors/performance'

import DealList from './deal-list'

export class DealListContainer extends Component {

  render() {
    return <DealList {...this.props} />
  }

}

DealListContainer.propTypes = {
  currencyCode: PropTypes.string,
  deals: PropTypes.array,
  dealsErrors: PropTypes.object,
  editable: PropTypes.bool,
  onChange: PropTypes.func,
  saving: PropTypes.bool,
}

function mapStateToProps(state) {
  return {
    dealsErrors: getDealsErrors(state),
  }
}

export default connect(mapStateToProps)(DealListContainer)



/** WEBPACK FOOTER **
 ** ./src/components/deal-list/deal-list-container.js
 **/